import { render, staticRenderFns } from "./ClientInputConfirm.vue?vue&type=template&id=dfc6f15c&scoped=true"
import script from "./ClientInputConfirm.vue?vue&type=script&lang=js"
export * from "./ClientInputConfirm.vue?vue&type=script&lang=js"
import style0 from "./ClientInputConfirm.vue?vue&type=style&index=0&id=dfc6f15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc6f15c",
  null
  
)

export default component.exports